import IconButton from '@material-ui/core/IconButton';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import clsx from 'clsx';
import * as React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      padding: 4,
      fontSize: '1rem',
      color: theme.palette.error.contrastText,
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.dark
      }
    }
  })
);

const RemoveFieldButton = ({ onClick, searchFieldId, className, ...buttonProps }: any) => {
  const classes = useStyles();

  return (
    <IconButton
      aria-label="remove"
      className={clsx(classes.button, className)}
      onClick={onClick.bind(null, searchFieldId)}
      {...buttonProps}
    >
      <Close fontSize="inherit" />
    </IconButton>
  );
};
export default RemoveFieldButton;
